export const SentryErrorFallback = () => {
  return <div>An error has occurred. Please reload the page.</div>
}
